import ClientPassengerInterface from '../../interfaces/client/Passenger'

export const ADD_UPLOADED_PASSENGERS = 'ADD_UPLOADED_PASSENGERS'

export default (passengers: ClientPassengerInterface[]) => ({
  type: ADD_UPLOADED_PASSENGERS,
  passengers,
})
